<template>
  <div class="setting-userinfo">
      <transition name="fade-transform" mode="out-in">
        <router-view/>
      </transition>
  </div>
</template>

<script>
  export default {
    name: 'setting-userinfo',
    data() {
      return {
        imageUrl: '',


      }
    },
    computed:{
      tabbar(){
        let menu = []
        let currenMenuMatched = this.$route.matched
        this.$store.state.permission.addRoutes.map((item) => {
          if(item.name == 'layout'){
            item.children.map( subItem => {
              if(subItem.path == currenMenuMatched[1].path){
                subItem.children.map( subSubItem => {
                  if(subSubItem.path == currenMenuMatched[2].path){
                    subSubItem.children.map( subSunSubItem => {
                      if(subSunSubItem.path == currenMenuMatched[3].path){
                        menu = subSunSubItem.children
                      }
                    })
                  }
                })
              }
            })
          }
        })
        return menu
      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style lang="scss">
  .setting-userinfo {
    .setting-userinfo-tab-container {
      display: flex;
      padding: 24px 24px 17px;

      li {
        margin-right: 40px;
        color: #333333;
        font-size: 12px;
        letter-spacing: 1.4px;
        cursor: pointer;
        padding-bottom: 7px;
      }
    }

    .setting-userinfo-content-container {
      margin-top: 10px;
      padding: 22px;




    }
  }
</style>
